var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('KeysTable',{key:_vm.refreshKey})],1)],1),(_vm.fabs)?_c('Fab',{attrs:{"fabs":_vm.fabs},on:{"fab_action":_vm.fabAction}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }